// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeCouponApi = class EdgeCouponApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param getEnrollmentDetailsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async couponGetEnrollmentDetails(getEnrollmentDetailsRequestModel, xProgramId) {
        const _url_ = '/edge/coupon/GetEnrollmentDetails';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getEnrollmentDetailsRequestModel' is not null or undefined
        if (getEnrollmentDetailsRequestModel === null || getEnrollmentDetailsRequestModel === undefined) {
            throw new Error('Required parameter getEnrollmentDetailsRequestModel was null or undefined when calling couponGetEnrollmentDetails.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getEnrollmentDetailsRequestModel, "GetEnrollmentDetailsRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponGetEnrollmentDetailsDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param couponDocumentsSubmitDocumentsSubmitDocumentsRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async documentsSubmitDocuments(couponDocumentsSubmitDocumentsSubmitDocumentsRequest, xProgramId) {
        const _url_ = '/edge/coupon/Documents/submitDocuments';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'couponDocumentsSubmitDocumentsSubmitDocumentsRequest' is not null or undefined
        if (couponDocumentsSubmitDocumentsSubmitDocumentsRequest === null || couponDocumentsSubmitDocumentsSubmitDocumentsRequest === undefined) {
            throw new Error('Required parameter couponDocumentsSubmitDocumentsSubmitDocumentsRequest was null or undefined when calling documentsSubmitDocuments.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(couponDocumentsSubmitDocumentsSubmitDocumentsRequest, "CouponDocumentsSubmitDocumentsSubmitDocumentsRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponDocumentsSubmitDocumentsSubmitDocumentsResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param enrollmentRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async enrollmentBasicEnrollment(programId, enrollmentRequestModel, xProgramId) {
        const _url_ = '/edge/coupon/Enrollment/basicEnrollment/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentBasicEnrollment.');
        }
        // verify required parameter 'enrollmentRequestModel' is not null or undefined
        if (enrollmentRequestModel === null || enrollmentRequestModel === undefined) {
            throw new Error('Required parameter enrollmentRequestModel was null or undefined when calling enrollmentBasicEnrollment.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentRequestModel, "EnrollmentRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param enrollmentCommTypeUpdateRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async enrollmentCommunicationTypeUpdate(programId, enrollmentCommTypeUpdateRequestModel, xProgramId) {
        const _url_ = '/edge/coupon/Enrollment/communicationTypeUpdate/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentCommunicationTypeUpdate.');
        }
        // verify required parameter 'enrollmentCommTypeUpdateRequestModel' is not null or undefined
        if (enrollmentCommTypeUpdateRequestModel === null || enrollmentCommTypeUpdateRequestModel === undefined) {
            throw new Error('Required parameter enrollmentCommTypeUpdateRequestModel was null or undefined when calling enrollmentCommunicationTypeUpdate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentCommTypeUpdateRequestModel, "EnrollmentCommTypeUpdateRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentCommunicationTypeUpdateProgramIdCommunicationTypeUpdateResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param enrollmentUpdateRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async enrollmentDemographicsUpdate(programId, enrollmentUpdateRequestModel, xProgramId) {
        const _url_ = '/edge/coupon/Enrollment/demographicsUpdate/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentDemographicsUpdate.');
        }
        // verify required parameter 'enrollmentUpdateRequestModel' is not null or undefined
        if (enrollmentUpdateRequestModel === null || enrollmentUpdateRequestModel === undefined) {
            throw new Error('Required parameter enrollmentUpdateRequestModel was null or undefined when calling enrollmentDemographicsUpdate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentUpdateRequestModel, "EnrollmentUpdateRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param enrollmentInsVerRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async enrollmentEnrollmentWithInsurance(programId, enrollmentInsVerRequestModel, xProgramId) {
        const _url_ = '/edge/coupon/Enrollment/enrollmentWithInsurance/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentEnrollmentWithInsurance.');
        }
        // verify required parameter 'enrollmentInsVerRequestModel' is not null or undefined
        if (enrollmentInsVerRequestModel === null || enrollmentInsVerRequestModel === undefined) {
            throw new Error('Required parameter enrollmentInsVerRequestModel was null or undefined when calling enrollmentEnrollmentWithInsurance.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentInsVerRequestModel, "EnrollmentInsVerRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param enrollmentPatientLookupRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async enrollmentPatientMedicalBenefit(programId, enrollmentPatientLookupRequestModel, xProgramId) {
        const _url_ = '/edge/coupon/Enrollment/patientMedicalBenefit/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentPatientMedicalBenefit.');
        }
        // verify required parameter 'enrollmentPatientLookupRequestModel' is not null or undefined
        if (enrollmentPatientLookupRequestModel === null || enrollmentPatientLookupRequestModel === undefined) {
            throw new Error('Required parameter enrollmentPatientLookupRequestModel was null or undefined when calling enrollmentPatientMedicalBenefit.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentPatientLookupRequestModel, "EnrollmentPatientLookupRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse");
        }
        return response;
    }
    /**
     *
     * @param couponMemberMemberNumberStatusMemberNumberStatusRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async memberMemberNumberStatus(couponMemberMemberNumberStatusMemberNumberStatusRequest, xProgramId) {
        const _url_ = '/edge/coupon/Member/MemberNumberStatus';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'couponMemberMemberNumberStatusMemberNumberStatusRequest' is not null or undefined
        if (couponMemberMemberNumberStatusMemberNumberStatusRequest === null || couponMemberMemberNumberStatusMemberNumberStatusRequest === undefined) {
            throw new Error('Required parameter couponMemberMemberNumberStatusMemberNumberStatusRequest was null or undefined when calling memberMemberNumberStatus.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(couponMemberMemberNumberStatusMemberNumberStatusRequest, "CouponMemberMemberNumberStatusMemberNumberStatusRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponMemberMemberNumberStatusMemberNumberStatusResponse");
        }
        return response;
    }
    /**
     *
     * @param couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async memberMemberNumberStatusWithProgram(couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest, xProgramId) {
        const _url_ = '/edge/coupon/Member/MemberNumberStatusWithProgram';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest' is not null or undefined
        if (couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest === null || couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest === undefined) {
            throw new Error('Required parameter couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest was null or undefined when calling memberMemberNumberStatusWithProgram.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest, "CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param enrollmentMoveMemberNumberBySurveyQuestionRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async memberMoveMemberNumberBySurveyQuestion(programId, enrollmentMoveMemberNumberBySurveyQuestionRequestModel, xProgramId) {
        const _url_ = '/edge/coupon/Member/MoveMemberNumberBySurveyQuestion/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling memberMoveMemberNumberBySurveyQuestion.');
        }
        // verify required parameter 'enrollmentMoveMemberNumberBySurveyQuestionRequestModel' is not null or undefined
        if (enrollmentMoveMemberNumberBySurveyQuestionRequestModel === null || enrollmentMoveMemberNumberBySurveyQuestionRequestModel === undefined) {
            throw new Error('Required parameter enrollmentMoveMemberNumberBySurveyQuestionRequestModel was null or undefined when calling memberMoveMemberNumberBySurveyQuestion.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentMoveMemberNumberBySurveyQuestionRequestModel, "EnrollmentMoveMemberNumberBySurveyQuestionRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponMemberMoveMemberNumberBySurveyQuestionProgramIdMoveMemberNumberBySurveyQuestionResponse");
        }
        return response;
    }
    /**
     *
     * @param couponMemberReplaceCardReplaceCardRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async memberReplaceCard(couponMemberReplaceCardReplaceCardRequest, xProgramId) {
        const _url_ = '/edge/coupon/Member/ReplaceCard';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'couponMemberReplaceCardReplaceCardRequest' is not null or undefined
        if (couponMemberReplaceCardReplaceCardRequest === null || couponMemberReplaceCardReplaceCardRequest === undefined) {
            throw new Error('Required parameter couponMemberReplaceCardReplaceCardRequest was null or undefined when calling memberReplaceCard.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(couponMemberReplaceCardReplaceCardRequest, "CouponMemberReplaceCardReplaceCardRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponMemberReplaceCardReplaceCardResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param medicalBenefitRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientMedicalBenefitLookUp(programId, medicalBenefitRequest, xProgramId) {
        const _url_ = '/edge/coupon/Patient/medicalBenefitLookUp/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling patientMedicalBenefitLookUp.');
        }
        // verify required parameter 'medicalBenefitRequest' is not null or undefined
        if (medicalBenefitRequest === null || medicalBenefitRequest === undefined) {
            throw new Error('Required parameter medicalBenefitRequest was null or undefined when calling patientMedicalBenefitLookUp.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(medicalBenefitRequest, "MedicalBenefitRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponPatientMedicalBenefitLookUpProgramIdMedicalBenefitLookUpResponse");
        }
        return response;
    }
    /**
     *
     * @param patientSearchRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientPatientSearch(patientSearchRequestModel, xProgramId) {
        const _url_ = '/edge/coupon/Patient/patientSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'patientSearchRequestModel' is not null or undefined
        if (patientSearchRequestModel === null || patientSearchRequestModel === undefined) {
            throw new Error('Required parameter patientSearchRequestModel was null or undefined when calling patientPatientSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientSearchRequestModel, "PatientSearchRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponPatientPatientSearchPatientSearchResponse");
        }
        return response;
    }
    /**
     *
     * @param redemptionListRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async redemptionFullRedemptionList(redemptionListRequestModel, xProgramId) {
        const _url_ = '/edge/coupon/Redemption/fullRedemptionList';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'redemptionListRequestModel' is not null or undefined
        if (redemptionListRequestModel === null || redemptionListRequestModel === undefined) {
            throw new Error('Required parameter redemptionListRequestModel was null or undefined when calling redemptionFullRedemptionList.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(redemptionListRequestModel, "RedemptionListRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponRedemptionFullRedemptionListFullRedemptionListResponse");
        }
        return response;
    }
    /**
     *
     * @param redemptionListRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async redemptionList(redemptionListRequestModel, xProgramId) {
        const _url_ = '/edge/coupon/Redemption/List';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'redemptionListRequestModel' is not null or undefined
        if (redemptionListRequestModel === null || redemptionListRequestModel === undefined) {
            throw new Error('Required parameter redemptionListRequestModel was null or undefined when calling redemptionList.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(redemptionListRequestModel, "RedemptionListRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponRedemptionListListResponse");
        }
        return response;
    }
};
EdgeCouponApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeCouponApi);
export { EdgeCouponApi };
//# sourceMappingURL=edgeCouponApi.js.map